import VueSingleSelect from "vue-single-select";

import { VMoney } from 'v-money'
import { axiosRequest } from '../../utils/Requests.js';
import { getReais, getCentavos, getNumeroSemFormatacao } from '../../utils/Utils.js'

export default {
  components: { 
    VueSingleSelect
  },
  directives: { money: VMoney },
  props: [ 'rota', 'imobiliaria', 'parametros' ],
  data() {
    return {
      titulo: "",
      loadingImoveis: true,
      tabAtiva: '',
      quantidade: 0,
      imoveis: [],
      pagina: 0,
      totalPaginas: 0,
      cidadeBairro: null,
      ordenacaoSelecionada: null,
      tipoImovelSelecionado: null,
      quartosSelecionado: null,
      areaSelecionada: null,

      keyValorMinimo: 0,
      keyValorMaximo: 0,
      valorMinimo: undefined,
      valorMaximo: undefined,

      valorOrder: 'asc',

      modalFiltrosAberto: false,
      textoBuscaLocalizacao: '',

      imagemComErro: {},

      params: {
        operacao: undefined,
        bairro: undefined,
        cidade: undefined,
        valorMinimo: undefined,
        valorMaximo: undefined,
        tipoImovel: null,
        quartos: null,
        area: null
      },

      moneyMask: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    somenteAluguel() { return this.imobiliaria.aluguel && !this.imobiliaria.venda },
    somenteVenda() { return this.imobiliaria.venda && !this.imobiliaria.aluguel },
    ambos() { return this.imobiliaria.venda && this.imobiliaria.aluguel },

    listaCidadesBairros() {
      let array = this.imobiliaria.cidades.map((cidade) => { return { nome: cidade.nome, id: cidade.id } })
      array = array.concat(this.imobiliaria.bairros.map((bairro) => { return { nome: bairro.nome + ' (' + bairro.cidade.nome + ')', id: bairro.cidade.id + "-" + bairro.id } }))
      return array
    },

    listaCidadesBairrosDinamica() {

      if (this.cidadeBairro) return this.listaCidadesBairros;

      if (!this.textoBuscaLocalizacao || this.textoBuscaLocalizacao.length < 1) {
        return [];
      }

      return this.listaCidadesBairros;
    },

    listaOrdenacao() {
      return [
        { nome: 'Menor Valor', id: 'asc' },
        { nome: 'Maior Valor', id: 'desc' }
      ]
    },

    listaQuartos() {
      return [
        { nome: 'Qualquer', id: null },
        { nome: '01', id: 1 },
        { nome: '02', id: 2 },
        { nome: '03', id: 3 },
        { nome: '04+', id: 4 }
      ]
    },

    listaArea() {
      return [
        { nome: 'Qualquer', id: null },
        { nome: 'Até 100m²', id: 100 },
        { nome: 'Entre 101 e 150', id: 101 },
        { nome: 'Entre 151 e 200', id: 151 },
        { nome: 'Entre 201 e 250', id: 201 },
        { nome: 'Entre 251 e 300', id: 251 },
        { nome: 'Acima de 300m²', id: 300 }
      ]
    },

    textoQuantidade() {
      if(this.loadingImoveis) { return "Carregando imóveis" }
      if(this.quantidade == 0) { return "Nenhum imóvel encontrado" }
      if(this.quantidade == 1) { return "1 imóvel para " + this.$route.params.operacao }
      
      return this.quantidade + " imóveis para " + this.$route.params.operacao
    },
    
    textoExibicaoInicio() {
      if (this.quantidade === 0) return 0;
      return (this.pagina * 9) + 1;
    },
    textoExibicaoFim() {
      const fim = (this.pagina + 1) * 9;
      return fim > this.quantidade ? this.quantidade : fim;
    },

    exibirPaginacao() { return this.totalPaginas >= 1 },

    desabilitarBotaoPaginaAnterior() { return this.pagina == 0 || this.loadingImoveis },
    desabilitarBotaoProximaPagina() { return this.pagina == this.totalPaginas || this.loadingImoveis }
  },
  watch: {
    modalFiltrosAberto(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden'; // Trava o fundo
      } else {
        document.body.style.overflow = '';       // Destrava o fundo
      }
    },
    'valorMinimo'(newValue) {
      if(newValue == "0" || newValue == "0,0" || newValue == "0,00" ) {
        this.valorMinimo = undefined
        this.params.valorMinimo = undefined
        this.keyValorMinimo++
        this.$nextTick(() => this.$refs.valorMinimoInput.focus())
      } else {
        this.params.valorMinimo = (parseFloat(getNumeroSemFormatacao(newValue)) ? parseFloat(getNumeroSemFormatacao(newValue)) : undefined)
      }
    },
    'valorMaximo'(newValue) {
      if(newValue == "0" || newValue == "0,0" || newValue == "0,00" ) {
        this.valorMaximo = undefined
        this.params.valorMaximo = undefined
        this.keyValorMaximo++
        this.$nextTick(() => this.$refs.valorMaximoInput.focus())
      } else {
        this.params.valorMaximo = (parseFloat(getNumeroSemFormatacao(newValue)) ? parseFloat(getNumeroSemFormatacao(newValue)) : undefined)
      }
    },
    cidadeBairro(newValue) {
      if(!newValue) {
        this.textoBuscaLocalizacao = ''; 
        this.params.cidade = undefined
        this.params.bairro = undefined
        return
      }

      let array = newValue.id.toString().split("-")
      this.params.cidade = (array[0] ? array[0] : undefined)
      this.params.bairro = (array[1] ? array[1] : undefined)

      if (newValue.nome && newValue.nome.includes('(') && !newValue._isStripped) {
        const nomeLimpo = newValue.nome.replace(/\s*\(.*\)$/, '');
        this.cidadeBairro = {
          id: newValue.id,
          nome: nomeLimpo,
          _isStripped: true
        };
      }
    },
    ordenacaoSelecionada(newValue) {
      if (newValue && newValue.id === 'asc') {
        this.$nextTick(() => { this.ordenacaoSelecionada = null; });
        this.valorOrder = 'asc';
      } else {
        this.valorOrder = newValue ? newValue.id : 'asc';
      }
    },
    tipoImovelSelecionado(newValue) {
      this.params.tipoImovel = newValue ? newValue.id : null;
    },
    quartosSelecionado(newValue) {
      if (newValue && newValue.id === null) {
        this.$nextTick(() => { this.quartosSelecionado = null; });
        this.params.quartos = null;
      } else {
        this.params.quartos = newValue ? newValue.id : null;
      }
    },
    areaSelecionada(newValue) {
      if (newValue && newValue.id === null) {
        this.$nextTick(() => { this.areaSelecionada = null; });
        this.params.area = null;
      } else {
        this.params.area = newValue ? newValue.id : null;
      }
    },
    titulo() {
      document.title = this.titulo + " | " + this.imobiliaria.nome
    },
    '$route' (to) {
      this.tabAtiva = to.params.operacao
      this.quantidade = 0
      this.pagina = 0
      this.totalPaginas = 0

      this.valorMinimo = undefined
      this.valorMaximo = undefined
      this.ordenacaoSelecionada = null;
      this.tipoImovelSelecionado = null;
      this.quartosSelecionado = null;
      this.areaSelecionada = null;
      
      this.textoBuscaLocalizacao = ''; 

      this.params = {
        operacao: undefined,
        bairro: undefined,
        cidade: undefined,
        valorMinimo: undefined,
        valorMaximo: undefined,
        tipoImovel: null,
        quartos: null,
        area: null
      }

      this.setarParametrosURL()
      this.listarImoveis()
      this.montarTitulo()
    },
  },
  created() {
    this.setarParametrosURL()
    this.listarImoveis()
    this.montarTitulo()
  },
  mounted() {
    setTimeout(() => {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const btn = document.getElementById('btn-mobile-filtros');
          if (btn) {
            if (entries[0].isIntersecting) {
              btn.classList.add('ocultar-btn-flutuante');
            } else {
              btn.classList.remove('ocultar-btn-flutuante');
            }
          }
        }, {
          root: null,
          threshold: 0, 
          rootMargin: "0px 0px 50px 0px" 
        });

        const paginacao = document.querySelector('.paginacao-moderna');
        if (paginacao) {
          observer.observe(paginacao);
        }
      }
    }, 1000);
  },
  methods: {
    getReais,
    getCentavos,
    getNumeroSemFormatacao,
    setData(resultado) {
      this.tabAtiva = this.$route.params.operacao
      
      this.imoveis = resultado.lista
      this.quantidade = resultado.quantidade
      this.totalPaginas = resultado.totalPaginas
      
      this.loading = false;
      this.loadingImoveis = false;
    },

    marcarErroImagem(imovel) {
      this.$set(this.imagemComErro, imovel.id, true)
    },

    pesquisar() {
      this.params.operacao = (this.tabAtiva == "alugar" ? "ALUGUEL" : "VENDA")
      this.pagina = 0;

      this.modalFiltrosAberto = false;

      this.$router.push(this.montarURL())
      this.listarImoveis()
      this.montarTitulo()
    },

    proximaPagina() {
      if(this.pagina < this.totalPaginas) { this.pagina += 1 }
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, pagina: this.pagina } })
      this.listarImoveis()
    },
    paginaAnterior() {
      if(this.pagina > 0) { this.pagina -= 1 }
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, pagina: this.pagina } })
      this.listarImoveis()
    },
    listarImoveis() {
      this.loadingImoveis = true;

      this.params.sort = this.montarParametroSort();

      axiosRequest.post("/imoveis?pagina=" + this.pagina, this.params)
      .then((resultado) => {
        this.setData(resultado.data)
      }).catch(() => {
        this.pagina += 1
        this.loadingImoveis = false;
      });
    },
    montarURL() {
      return {
        path: this.montarParametroURL(),
        query: { 
          pagina: this.pagina,
          valorMinimo: (this.params.valorMinimo ? this.params.valorMinimo : undefined),
          valorMaximo: (this.params.valorMaximo ? this.params.valorMaximo : undefined),
          quartos: (this.params.quartos ? this.params.quartos : undefined),
          area: (this.params.area ? this.params.area : undefined)
        }
      }
    },

    montarParametroSort() {
      const fieldOrderPairs = [
        this.montarParametroSortValor(),
      ];

      const paramValue = fieldOrderPairs.join();

      return paramValue;
    },

    montarParametroSortValor() {
      return this.getFieldOrderPair('valor', this.valorOrder);
    },

    getFieldOrderPair(field, order) {
      const fieldOrderPair = [field, order];

      return fieldOrderPair.join('.');
    },

    montarParametroURL() {
      var texto = "/imoveis/" + this.tabAtiva

      let tipo = this.imobiliaria.tiposImovel.filter( (tipo) => { return tipo.id == this.params.tipoImovel })[0];
      if(tipo) { texto += "/" + tipo.key }

      let cidade = this.imobiliaria.cidades.filter( (cidade) => { return cidade.id == this.params.cidade })[0];
      if(cidade) { texto += "/" + cidade.key }

      let bairro = this.imobiliaria.bairros.filter( (bairro) => { return bairro.id == this.params.bairro })[0];
      if(bairro) { texto += "/" + bairro.key }

      return texto;
    },
    setarParametrosURL() {
      if(this.$route.params.operacao == "alugar") { this.params.operacao = "ALUGUEL"; this.tabAtiva = "alugar" }
      if(this.$route.params.operacao == "comprar") { this.params.operacao = "VENDA"; this.tabAtiva = "comprar" }

      this.setarParametro(this.$route.params.param1)
      this.setarParametro(this.$route.params.param2)
      this.setarParametro(this.$route.params.param3)

      this.setarParametroQuery()

      if(this.params.bairro) {
        this.cidadeBairro = this.listaCidadesBairros.filter((cidadeBairro) => { return cidadeBairro.id == this.params.cidade + "-" + this.params.bairro })[0]
      } else if(this.params.cidade) {
        this.cidadeBairro = this.listaCidadesBairros.filter((cidadeBairro) => { return cidadeBairro.id == this.params.cidade })[0]
      }

      this.ordenacaoSelecionada = this.valorOrder !== 'asc' ? this.listaOrdenacao.find((o) => o.id == this.valorOrder) : null;
      this.tipoImovelSelecionado = this.params.tipoImovel ? this.imobiliaria.tiposImovel.find((t) => t.id == this.params.tipoImovel) : null;
      this.quartosSelecionado = this.params.quartos ? this.listaQuartos.find((q) => q.id == this.params.quartos) : null;
      this.areaSelecionada = this.params.area ? this.listaArea.find((a) => a.id == this.params.area) : null;
    },
    setarParametro(parametro) {
      if(parametro) {
        let tipo = this.imobiliaria.tiposImovel.filter( (tipo) => { return tipo.key == parametro })[0]
        if(tipo) { this.params.tipoImovel = tipo.id; return; }
        
        let cidade = this.imobiliaria.cidades.filter( (cidade) => { return cidade.key == parametro })[0]
        if(cidade) { this.params.cidade = cidade.id; return; }

        let bairro = this.imobiliaria.bairros.filter( (bairro) => { return bairro.key == parametro })[0]
        if(bairro) { this.params.bairro = bairro.id; return; }
      }
    },
    setarParametroQuery() {
      let query = this.$route.query 

      if(parseInt(query.pagina)) { this.pagina = parseInt(query.pagina) } else { this.pagina = 0 }
      if(query.valorMinimo) { this.valorMinimo = parseFloat(query.valorMinimo).toFixed(2) }
      if(query.valorMaximo) { this.valorMaximo = parseFloat(query.valorMaximo).toFixed(2) }
      if(query.quartos) { this.params.quartos = parseInt(query.quartos); } else { this.params.quartos = null; }
      if(query.area) { this.params.area = parseInt(query.area); } else { this.params.area = null; }
    },
    montarTitulo() {
      let texto = ""
      let tipo = this.imobiliaria.tiposImovel.filter((tipo) => { return tipo.id == this.params.tipoImovel })[0]
      let bairro = this.imobiliaria.bairros.filter((bairro) => { return bairro.id == this.params.bairro })[0]
      let cidade = this.imobiliaria.cidades.filter((cidade) => { return cidade.id == this.params.cidade })[0]

      texto += (tipo ? tipo.plural : "Imóveis") + " para " + this.tabAtiva
      if(bairro) {
        texto += " - " + bairro.nome + ", " + bairro.cidade.nome
      } else {
        texto += (cidade ? " em " + cidade.nome : "")
      }
      
      this.titulo = texto
    }
  }
}